/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div.informed-avalista[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center}div.informed-avalista[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{margin-left:5px}div.informed-avalista[_ngcontent-%COMP%], div.informed-avalista[_ngcontent-%COMP%]   span.glyphicon[_ngcontent-%COMP%]{color:#00185c!important}"];
export { styles as styles };
